<template>
  <div class="Details">
    <div class="DataTitle">
      <Title :productName="MateDatainfo.productName"></Title>
      <div class="btn_box">
        <Button
          v-for="(item, index) in btnData"
          @click.native="btn_Fun(item.funType)"
          :key="index"
          :Data="item"
        ></Button>
      </div>
    </div>
    <DataCreateInsti :DataCreate="MateDatainfo"></DataCreateInsti>
    <DataInfo :DataInfo="MateDatainfo"></DataInfo>
    <Description :Description="MateDatainfo"></Description>
    <MetaDataInfo :MetaDataInfo="MateDatainfo"></MetaDataInfo>
    <!-- <Declaration :Declaration="MateDatainfo"></Declaration> -->
    <!-- <Copyright></Copyright> -->

    <DataTable :DataTable="MateDatainfo"></DataTable>
  </div>
</template>

<script>
import bus from "@/bus";
import { Collect } from "@/axios/datashare.js";
export default {
  props: ["MateDatainfo"],
  data() {
    return {};
  },
  computed: {
    btnData() {
      return [
        {
          name: this.$t("DataDetails.collectionDatasets"),
          funType: "collect",
          iconfont: "iconfont icon-shoucang6",
          border: "1px solid rgba(18, 139, 237, 1)",
          background: "rgba(18, 139, 237, 1)",
          color: "#fff",
        },
      ];
    },
  },
  mounted() {
    console.log(this.MateDatainfo);
  },
  methods: {
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName");
    },

    btn_Fun(type) {
      if (type == "collect") {
        var userVerifyLogin = this.verifyLogin();
        if (!userVerifyLogin) {
          bus.$emit("LoginDialogEmit");
          return;
        }
        // alert('收藏数据集')
        // console.log(this.MateDatainfo);
        this.CollectFun().then((res) => {
          this.$message.closeAll();
          this.$message({ message: this.$t('DataDetails.tip.collectSuccessfully'), type: "success" ,duration:1000});
        });
      }
    },
    async CollectFun() {
      console.log(this.MateDatainfo);
      var param = {
        productCode: this.MateDatainfo.dataId,
        productName: this.MateDatainfo.productName,
        thumbnail: this.MateDatainfo.image,
      };

      return await Collect(param);
    },
  },
  components: {
    Button: () => import("@/components/DataDetails/Details/Button.vue"),
    Title: () => import("@/components/DataDetails/Details/Title.vue"),
    DataCreateInsti: () =>
      import("@/components/DataDetails/Details/DataCreateInsti.vue"),
    DataInfo: () => import("@/components/DataDetails/Details/DataInfo.vue"),
    Description: () =>
      import("@/components/DataDetails/Details/Description.vue"),
    Declaration: () =>
      import("@/components/DataDetails/Details/Declaration.vue"),
    ModuleName: () =>
      import("@/components/DataDetails/Details/Declaration.vue"),
    MetaDataInfo: () =>
      import("@/components/DataDetails/Details/MetaDataInfo.vue"),
    Copyright: () => import("@/components/DataDetails/Details/Copyright.vue"),
    DataTable: () => import("@/components/DataDetails/Details/DataTable.vue"),
  },
};
</script>

<style lang="scss" scoped>
.Details {
  padding: 20px 20px;
  width: 865px;
  background: #fff;
  .DataTitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .btn_box {
      display: flex;
    }
  }
}
</style>